// ---------------------------------------------------------------------------
// Mapping stable : titre français de mission → préfixe de clé catalogue i18n.
//
// Situé dans la couche présentation — le domaine ne connaît ni ces clés ni le
// catalogue. Les titres français servent d'identifiants de fait car le seed
// data MVP ne possède pas d'ID stable par mission ; ce mapping sera remplacé
// par un `missionKey` dans le domaine dès qu'un ID stable existera.
// ---------------------------------------------------------------------------

/** Préfixe de clé catalogue pour chaque mission du seed MVP. */
export const MISSION_I18N_MAP: Record<string, string> = {
  'Réveil sans téléphone': 'mission.wake_without_phone',
  'Préparation mentale': 'mission.mental_preparation',
  'Séance de sport': 'mission.sport_session',
  'Douche et récupération': 'mission.shower_recovery',
  'Planification de la journée': 'mission.day_planning',
  'Travail profond': 'mission.deep_work',
  'Action de croissance': 'mission.growth_action',
  'Relation consciente': 'mission.conscious_relationship',
  'Bilan du soir': 'mission.evening_review',
  'Rituel avant de dormir': 'mission.bedtime_ritual',
  'Boire de l\'eau': 'mission.drink_water',
  'Boire de l’eau': 'mission.drink_water',
  'Respiration consciente': 'mission.conscious_breathing',
};

/** Résout le titre d'une mission via le catalogue i18n. */
export function resolveMissionTitle(frenchTitle: string, t: (key: string) => string): string {
  const prefix = MISSION_I18N_MAP[frenchTitle];
  if (!prefix) return frenchTitle;
  return t(`${prefix}.title`);
}

/** Résout l'objectif d'une mission via le catalogue i18n. */
export function resolveMissionObjective(frenchTitle: string, t: (key: string) => string): string {
  const prefix = MISSION_I18N_MAP[frenchTitle];
  if (!prefix) return '';
  return t(`${prefix}.objective`);
}

/** Résout une instruction de mission via le catalogue i18n. */
export function resolveMissionInstruction(frenchTitle: string, index: number, t: (key: string) => string): string {
  const prefix = MISSION_I18N_MAP[frenchTitle];
  if (!prefix) return '';
  return t(`${prefix}.instruction.${index}`);
}
